import { Api } from '../api/Api.js'

export function apiGetLoad(load_id) {
  return Api('get', '/loads/get_load?load_id=' + load_id )
}
